// Ops plan 2026-10-29-settle-unconfirmed-refunds (review of #2594, B-2): the Check Again failures a hand settle may follow.
// No imports: contracts reads this file at runtime (`@radish/core/payments/settle-checks`).

/**
 * The Check Again failures after which the processor can't and won't say what happened to the try: the lookup found no
 * record after Datacap's indexing lag, the location has no processor any more, or the device's credential was refused.
 * A leg may be settled either way after one of these (Not refunded only once the try is old enough: SETTLE_NOT_REFUNDED_AFTER_MS).
 */
export const SETTLE_FINAL_CHECKS = ['payments.card_operation_needs_review', 'payments.processor_not_set', 'unauthenticated', 'forbidden'] as const;
/**
 * The Check Again failures that may only mean the first try is still running (the processor unreachable, a 5xx, an
 * answer lost again). After one of these a leg may be settled only as Refunded, where the processor's reference is the
 * evidence: Not refunded could record a failure while the card is being refunded (review of #2594, B-2).
 * `online.refund_unknown` is one: the cloud answers it for a lost answer its lookup can't settle yet, for an ask that
 * lost the journal to another still sending, and for a gateway that threw. An online refund is settled Not refunded in
 * the cloud instead (`online.settleCardRefund`, which moves the journal row itself), never on the register (R-1).
 */
export const SETTLE_PENDING_CHECKS = ['card_operation_pending', 'payments.card_operation_unknown', 'payments.processor_unreachable', 'online.refund_unknown'] as const;

/**
 * A leg is settled Not refunded only once its refund was requested this long ago (review of #2594, S-5): a credential
 * refused or a processor removed on the Check Again says nothing about a first try still inside the cloud's timeouts
 * (up to about 240 s: a 120 s token lookup and a 120 s send).
 */
export const SETTLE_NOT_REFUNDED_AFTER_MS = 5n * 60_000n;
/** Every Check Again failure a settle may follow. */
export const SETTLE_CHECKS = [...SETTLE_FINAL_CHECKS, ...SETTLE_PENDING_CHECKS] as const;
export type SettleCheck = (typeof SETTLE_CHECKS)[number];
